import React from "react";
import { Screen } from '~common/screen';
import { StyledScreen } from '~common/screen';
import { Styled } from './styled';
import { useIsMobile } from "~helpers/hooks/useIsMobile";
import { AmplitudeCounter } from "~/amplitude-counter";

const SoftphoneScreen = () => {
  const isMobile = useIsMobile();

  return (
    <Screen id='softphone'>
      <Styled.Container>
        <Styled.Col>
          <Styled.Title><StyledScreen.GreenText>Самый стабильный*</StyledScreen.GreenText><br/>софтфон</Styled.Title>
          {
            isMobile &&
            <Styled.Icon>
              <Styled.IconImage><img src={process.env.PUBLIC_DIR + '/images/softon-image.png'} alt='mobile'/></Styled.IconImage>
              <Styled.IconImageRating><img src={process.env.PUBLIC_DIR + '/images/calls-rating.svg'} /></Styled.IconImageRating>
            </Styled.Icon>
          }
          <Styled.Text>
            Софтфон – это приложение для звонков через интернет. С ним вам не нужен IP-телефон и вы не привязаны к офису.<br/><br/>
            Звонки фиксируются в АТС и CRM — вы их не потеряете и сможете прослушать запись разговора.<br/><br/>
            *высшая оценка в AppStore среди аналогов
          </Styled.Text>
          <Styled.Badges>
            <Styled.Badge>
              <a
                href='https://apps.apple.com/ru/app/onlinepbx/id1444397107'
                target='_blank'
                onClick={() => AmplitudeCounter('click_download_mobile', { service: 'AppStore' })}
              >
                <img src={process.env.PUBLIC_DIR + '/images/app-store-badge-black.svg'} />
              </a>
            </Styled.Badge>
            <Styled.Badge>
              <a
                href='https://play.google.com/store/apps/details?id=com.onlinepbx&hl=ru'
                target='_blank'
                onClick={() => AmplitudeCounter('click_download_mobile', { service: 'GooglePlay' })}
              >
                <img src={process.env.PUBLIC_DIR + '/images/google-play-badge-black.svg'} />
              </a>
            </Styled.Badge>
          </Styled.Badges>
        </Styled.Col>
        {
          !isMobile &&
          <Styled.Col>
              <Styled.IconWrapper>
                <Styled.Icon>
                  <Styled.IconImage><img src={process.env.PUBLIC_DIR + '/images/softon-image.png'} alt='mobile'/></Styled.IconImage>
                  <Styled.IconImageRating><img src={process.env.PUBLIC_DIR + '/images/calls-rating.svg'} /></Styled.IconImageRating>
                </Styled.Icon>
              </Styled.IconWrapper>
          </Styled.Col>
        }
      </Styled.Container>
    </Screen>
  )
}

export { SoftphoneScreen }
